<template>
    <section class="widget widget-txt" v-html="disclaimer">
    </section>
</template>

<script>
	import * as CONST from '../../utils/constants';

	export default {
		data: function () {
			return {
				disclaimer: CONST.globalProject.Disclaimer.Disclaimer,
			}
		}
    }
</script>